import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _CashRequestBudget } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicPage } from "../../../../theme/Component/BasicPage";


interface Props {
    idCashRequest?: any;
    cashRequestDate?: any;
}

export const CashRequestBudget = ({ idCashRequest, cashRequestDate }: Props) => {

    const CashRequestBudget = useDataBean(_CashRequestBudget);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idCashRequest, cashRequestDate])

    const getLista = () => {

        CashRequestBudget.instance.getCashRequestBudgetCatalog(idCashRequest, cashRequestDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const create = () => {
        CashRequestBudget.setBean({
            IDCashRequest: idCashRequest,
            cashRequestDate: cashRequestDate
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        CashRequestBudget.deleteItemVoid(CashRequestBudget.bean.IDCashRequestBudget).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        CashRequestBudget.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCashRequestBudget', visible: true },
        { title: 'Solicitud de Caja Menor', property: 'IDCashRequest', visible: true },
        { title: 'Fecha de Solicitud', property: 'CashRequestDate', visible: true },
        { title: 'ID Registro Factura', property: 'IDCashRequestItem', visible: true },
        { title: 'Causación Contable', property: 'FCMnemonic', visible: true },
        { title: 'Fecha Causación', property: 'FCDate', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Valor', property: 'BudgetValue', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicPage titulo="Informe de Rubros Presupuestales Legalizados">
                    <BasicTable body={lista} head={head} rowSet={CashRequestBudget.setBean}></BasicTable>

                </BasicPage>

                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={CashRequestBudget.bean.Name} onChange={CashRequestBudget.handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Description</label>
                            <textarea name="Description" className="form-control" value={CashRequestBudget.bean.Description} onChange={CashRequestBudget.handleChange} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}